import React from 'react';
import { Layers, X } from 'lucide-react';
import LayerPanel from './LayerPanel';

interface LayerExportModalProps {
  isOpen: boolean;
  onClose: () => void;
  imageId: number | null;
  imageUrl?: string;
  /** 書き出しファイル名のもと */
  baseFileName?: string;
}

/**
 * レイヤー分解パネルをモーダルで開く。
 * 詳細パネルは幅が狭くレイヤー一覧を並べにくいため、独立したモーダルにしている。
 */
const LayerExportModal: React.FC<LayerExportModalProps> = ({
  isOpen,
  onClose,
  imageId,
  imageUrl,
  baseFileName,
}) => {
  if (!isOpen || imageId === null) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" onClick={onClose} />

      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative flex max-h-[90vh] w-full max-w-4xl flex-col overflow-hidden rounded-lg bg-white shadow-xl">
          <div className="flex items-center justify-between border-b border-gray-200 px-6 py-4">
            <h2 className="flex items-center gap-2 text-lg font-semibold text-gray-900">
              <Layers className="h-5 w-5" />
              レイヤー分解
            </h2>
            <button
              onClick={onClose}
              className="text-gray-400 transition-colors hover:text-gray-500"
              aria-label="閉じる"
            >
              <X className="h-5 w-5" />
            </button>
          </div>

          <div className="overflow-y-auto px-6 py-5">
            <LayerPanel imageId={imageId} imageUrl={imageUrl} baseFileName={baseFileName} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LayerExportModal;
